var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 770,
    height: 1024,
    viewBox: "0 0 770 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "T\xC5\x81O_V2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M133.3 0.0999756C133.3 0.0999756 36.6 134.5 53.2 249.5C66.7 342.8 128.5 444.2 91.8 549.3C65.6 624.6 21.4 648.1 2.69999 773.1C-16 898.2 71.2 1024.1 71.2 1024.1H770V0.0999756H133.3Z",
    fill: "#6786BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueShape);
export default __webpack_public_path__ + "static/media/blueShape.8c6da9edb8093143d288bd008919d277.svg";
export { ForwardRef as ReactComponent };